/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootshopTransactionHistoryResponsePagination } from './LootshopTransactionHistoryResponsePagination';
import {
    LootshopTransactionHistoryResponsePaginationFromJSON,
    LootshopTransactionHistoryResponsePaginationFromJSONTyped,
    LootshopTransactionHistoryResponsePaginationToJSON,
    LootshopTransactionHistoryResponsePaginationToJSONTyped,
} from './LootshopTransactionHistoryResponsePagination';
import type { LootshopTransactionHistoryItem } from './LootshopTransactionHistoryItem';
import {
    LootshopTransactionHistoryItemFromJSON,
    LootshopTransactionHistoryItemFromJSONTyped,
    LootshopTransactionHistoryItemToJSON,
    LootshopTransactionHistoryItemToJSONTyped,
} from './LootshopTransactionHistoryItem';

/**
 * 
 * @export
 * @interface LootshopTransactionHistoryResponse
 */
export interface LootshopTransactionHistoryResponse {
    /**
     * 
     * @type {Array<LootshopTransactionHistoryItem>}
     * @memberof LootshopTransactionHistoryResponse
     */
    transactions?: Array<LootshopTransactionHistoryItem>;
    /**
     * 
     * @type {LootshopTransactionHistoryResponsePagination}
     * @memberof LootshopTransactionHistoryResponse
     */
    pagination?: LootshopTransactionHistoryResponsePagination;
    /**
     * Applied time filter
     * @type {string}
     * @memberof LootshopTransactionHistoryResponse
     */
    timeFilter?: string;
    /**
     * Start date of filter period
     * @type {Date}
     * @memberof LootshopTransactionHistoryResponse
     */
    startDate?: Date;
    /**
     * End date of filter period
     * @type {Date}
     * @memberof LootshopTransactionHistoryResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the LootshopTransactionHistoryResponse interface.
 */
export function instanceOfLootshopTransactionHistoryResponse(value: object): value is LootshopTransactionHistoryResponse {
    return true;
}

export function LootshopTransactionHistoryResponseFromJSON(json: any): LootshopTransactionHistoryResponse {
    return LootshopTransactionHistoryResponseFromJSONTyped(json, false);
}

export function LootshopTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootshopTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(LootshopTransactionHistoryItemFromJSON)),
        'pagination': json['pagination'] == null ? undefined : LootshopTransactionHistoryResponsePaginationFromJSON(json['pagination']),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function LootshopTransactionHistoryResponseToJSON(json: any): LootshopTransactionHistoryResponse {
    return LootshopTransactionHistoryResponseToJSONTyped(json, false);
}

export function LootshopTransactionHistoryResponseToJSONTyped(value?: LootshopTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(LootshopTransactionHistoryItemToJSON)),
        'pagination': LootshopTransactionHistoryResponsePaginationToJSON(value['pagination']),
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

